import React, { Component } from 'react';
import moment from 'moment-timezone';
import 'moment/locale/es';
import 'moment/locale/fr';
import 'moment/locale/da';
import 'moment/locale/it';
import detectLanguage from '../lib/detect-language';

import '../../src/mobile/css/time.css';

import { en, es, fr, it } from '../locales/moment-overrides';

const currentLocale = detectLanguage() || 'en';

export const TIME_FORMAT_DEFAULT = 'default';
export const TIME_FORMAT_LONG = 'long';
export const TIME_FORMAT_SHORT = 'short';
export const TIME_FORMAT_SHORTER = 'shorter';
export const TIME_FORMAT_RELATIVE = 'relative';
export const TIME_FORMAT_COMPACT = 'compact';
export const TIME_FORMAT_HOUR = 'hour';
export const TIME_FORMAT_SHORT_WITH_HOUR = 'shortWithHour';

moment.updateLocale('en', {
  relativeTime: en,
});

moment.updateLocale('es', {
  relativeTime: es,
});

moment.updateLocale('fr', {
  relativeTime: fr,
});

moment.updateLocale('it', {
  relativeTime: it,
});

moment.locale(currentLocale);


export const timeDiff = (time, unit = 'hours') => {
  return Math.abs(moment(time).diff(moment(), unit));
};

export const moreThan180Days = (time) => {
  return timeDiff(time, 'days') >= 180;
};

export const timeFormats = {
  relative: (time, tz = null) => {
    return moment(time).fromNow();
  },
  short: (time, tz = null) => {
    if (tz) {
      return moment(time).tz(tz).format('MMM DD, YYYY z');
    }

    return moment(time).format('MMM DD, YYYY');

  },
  shorter: (time, tz = null) => {
    return moment(time).format('MMM D')
  },
  default: (time, tz = null) => {
    if (tz) {
      if (moreThan180Days(time)) return moment(time).tz(tz).format('DD MMM YYYY');
      return moment(time).tz(tz).format('DD MMM');
    }

    if (moreThan180Days(time)) return moment(time).format('DD MMM YYYY');
    return moment(time).format('DD MMM');
  },
  long: (time, tz = null) => {
    if (tz) {
      if (moreThan180Days(time)) return moment(time).tz(tz).format('DD MMM YYYY hh:mma z');
      return moment(time).tz(tz).format('DD MMM hh:mma z');
    }

    if (moreThan180Days(time)) return moment(time)
      .local().format('DD MMM YYYY hh:mma');
    return moment(time).local().format('DD MMM hh:mma');
  },
  compact: (time, tz = null) => {
    return moment(time).format('M/D/YY')
  },
  hour: (time, tz = null) => {
    if (tz) {
      return moment(time).tz(tz).format('hh:mma z');
    }

    return moment(time).format('hh:mma z');
  },
  shortWithHour: (time, tz = null) => {
    if (tz) {
      return moment(time).tz(tz).format('DD MMM HH:mm z')
    }

    return moment(time).format('DD MMM HH:mm z');
  },
};

export class Time extends Component {
  render() {
    moment.locale(detectLanguage() || 'en');

    let { format, time, timezone } = this.props;

    return (
      <span className="timetz">
        {timeFormats[format](time, timezone)}
      </span>

    );
  }
}

Time.defaultProps = {
  format: TIME_FORMAT_DEFAULT,
  time: Date.now(),
}



// WEBPACK FOOTER //
// ./src/components/Time.js